<template>
  <tbody id="id">
    <tr v-for="s in summary">
      <td colspan="5" class="empty"><button @click="newProduct">Dodaj</button></td>
      <th class="number">{{ s.vat }}</th>
      <td class="number">{{ money(s.nettoValue)}}</td>
      <td class="number">{{ money(s.vatValue) }}</td>
      <td class="number">{{ money(s.bruttoValue) }}</td>
    </tr>
  </tbody>
</template>

<script>
import accounting from 'accounting'

export default {
  props: ['products', 'id'],
  computed: {
    summary () {
      const answer = []
      const vats = {}
      this.products.forEach(p => {
        const vat = String(p.vat)
        const v = vats[vat] || { vat: p.vat, nettoValue: 0, vatValue: 0, bruttoValue: 0 }
        v.nettoValue += p.nettoValue
        v.vatValue += p.vatValue
        v.bruttoValue += p.bruttoValue
        vats[vat] = v
      })
      for (let k in vats) {
        answer.push(vats[k])
      }
      return answer.sort((a, b) => a - b)
    }
  },
  methods: {
    money (value) {
      return accounting.formatNumber(value / 100, 2, '.', ',')
    },
    newProduct () {
      this.$emit('new')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~assets/common.scss";

@media print {
  button {
    display: none !important;
  }
}
td,th {
  padding: 0.4em;
  position: relative;

  &.number {
    text-align: right;
  }
}
th {
  text-align: right;
  font-weight: normal;
}
button {
  display: none;
}
tr:first-child {
  button {
    @extend %canBeActive;
    display: inline;
    margin: -2pt;
    padding: 2pt;
    position: absolute;
    border: none;
    outline-style: none;
    left: -4em;
    width: 4em;

    &:focus {
      @extend %active;
    }
  }
}
tr:last-child {
  td, th {
    &.number {
      border-bottom: 1px solid $tableBorder;
    }
  }
}
</style>



/** WEBPACK FOOTER **
 ** InvoiceSummary.vue?68335abe
 **/